export const PAGE_TITLE = {
  numberOfApplicants: 'How many applicants will there be for this loan?',
  confirm: 'Please confirm the number of applicants',
  additionalApplicants: 'Please share information about the other applicants',
  information: 'Please share more information about the applicant',
  residency: "What is the applicant's residency status?",
  relationship: "What is the applicant's relationship status?",
  dependants: 'How many dependants does the applicant have?',
  creditHistory: "What's the applicant's credit history?",
  employmentType: "What's the applicant's employment type?",
  selfEmployed: 'Does the applicant have 2 years of Tax Returns?',
  repaymentType: "What's the applicant's current repayment type?",
  fixedRate: 'Are you currently on a fixed rate?',
  repayment: 'Tell us more about the current loan and repayment',
  residentialHistory: "The applicant's 3 years of residential history",
  firstHomeBuyer: 'Are you a first home buyer?',
  // employment
  currentEmployment: 'Tell us more about the current employment situation',
  additionalEmployment: 'Does the applicant have additional jobs?',
  employmentHistory: "The applicant's employment history",
  // income
  additionalIncome: 'Does the applicant have any additional source of income?',
  additionalApplicantsIncome: "Tell us more about the other applicants' employment",
  incomeSummary: "Here's a summary of your income",
  // expense
  expense: 'Tell us about the living expenses',
  expenseNext: "Tell us more about the other applicants' expenses",
  // liabilities
  creditCard: 'Do you have any credit or store cards?',
  loans: 'Do you have any other loans?',
  additionalLiabilities: 'Do you have any other liabilities?',
  liabilitiesSummary: "Here's a recap of your liabilities",
  // borrowingPower
  properties: 'How many properties will be included as part of this loan?',
  fhogStatus: 'Are you eligible for the First Home Owners Grant?',
  propertyStatus: 'What kind of property are you looking to buy?',
  purchasePrice: 'What is your expected purchase price?',
  debtConsolidation: 'Do you want to consolidate any debts?',
  // eConsent
  eConsent: 'Please read our privacy policy and e-consent to proceed',
  // guarantor
  guarantorEntry: 'Do you want to add a guarantor to your application?',
  guarantorRelationship: 'What is the relationship between the guarantor and the borrower?',
  borrowerSummary: "Borrowers' details",
  guarantorSummary: "Guarantors' details",
  propertySummary: "summary of the applicants' properties on the loan",
  borrowerLiabilitiesSummary: "Here's a summary of borrowers liabilities",
  guarantorLiabilitiesSummary: "Here's a summary of guarantors liabilities",
  borrowerExpenseSummary: "Here's a summary of borrowers expenses",
  guarantorExpenseSummary: "Here's a summary of guarantors expenses",
  borrowerResidentialHistorySummary: "Summary of borrowers' residential history",
  guarantorResidentialHistorySummary: "Summary of guarantors' residential history",
  borrowerIncomeSummary: `Borrowers' incomes`,
  guarantorIncomeSummary: `Guarantors' incomes`,
  borrowerPropertySummary: 'Here’s a summary of the borrowers properties on the loan',
  borrowerEmploymentHistorySummary: `Borrowers' employment history`,
  guarantorEmploymentHistorySummary: `Guarantors' employment history`,
  trustSummary: 'Here’s a summary of the trust applicants for this loan',
  companySummary: 'Here’s a summary of the company applicants for this loan',
  trustSettlorSummary: 'Here’s a summary of the trust settlor details',
};
